import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ClientService,
  ComponentOutputDO,
  AppMetadataHandler
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { take } from 'rxjs/operators';
@Component({
  selector: 'app-view-all-profiles',
  templateUrl: './view-all-profiles.component.html',
  styleUrls: ['./view-all-profiles.component.scss']
})
export class ViewAllProfilesComponent implements OnInit {

  _currentComponentName = 'ViewAllProfilesComponent'

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private clientService: ClientService,
    private interactService: InteractService,
    public appMetadataHandler: AppMetadataHandler) { }

  //Declaraions which might need developer input
  viewProfileSummaryForm: FormGroup
  VIEWPROFILESUMMARYFORM = "viewProfileSummaryForm"
  selectorOfThisComponent = 'app-view-all-profiles'
  parentEvent$

  @Output() componentOutput = new EventEmitter<any>();
  @Input() clinetDO: any;
  @Input() clientDOs: Array<any>;
  @Input() transactionState: any;
  @Input() extractRole: any
  tempSelectedClient: any;
  ClientDOListWithRole


  private _IO = null;
  @Input()
  set IO(value: any) {
    if(value){
      this._IO = value;
      this.ClientDOListWithRole = this.getClientDOlistWithRole(this._IO);
    }
    
  };

  selectedClient: any;
  get IO() {
    return this._IO;
  }

  /* CIBIL SCORE */
  formatCibil = (percent: number) => `${percent * 900 / 100}`;

  getClientDOlistWithRole(IO) {
    let DO = this.commonUtilty.getDO(IO)
    let clientRoleList = this.commonUtilty.getRoleNode(IO)
    let output = []
    if (this.commonUtilty.isArrayIterable(clientRoleList) && IO.clientDOs) {
      clientRoleList.forEach(clientRole => {
        let clientObject = IO.clientDOs.find(client => (client !== null && client.guid == clientRole.clientRefGuid))
        if (clientObject) {
          let mergedClient = Object.assign({}, clientObject, clientRole)
          output.push(mergedClient)
        }
      });
    }
    return output ? output : null
  }

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
      
    } catch (error) {
      
    }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
      
    } catch (error) {
      
    }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
      this.EmitComponentOutput(null);
    })
  }

  validateOutput(o) {
    this.commonUtilty.markAllFieldDirty(o);
    return true
  }


  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    if (this.IO != null)
      this.initializeProfileSummaryForm(this.IO)
    this.subscribeToParentEvent()
    this.subscribeToInsuredListAndInitializeRibbon();
  }

  initializeProfileSummaryForm(data?) {
    let payload = data || {}
    this.viewProfileSummaryForm = this.fb.group({

    });
  }

  getClientDO(IO) {
    let output = null
    if (IO != null) {
      switch (this.transactionState) {
        case "client": {
          if (IO['intimationDO'] || IO['claimDO'] || IO['preauthorizationDO']) {
            this.clinetDO = IO['clientDOs'];
            let clientRoles: any = [];
            if (IO['intimationDO'])
              clientRoles = IO['intimationDO']['claimClientRoles']

            if (IO['claimDO'])
              clientRoles = IO['claimDO']['claimClients'];

            if (IO['proposalDO'])
              clientRoles = IO['proposalDO']['proposalClients'];

            if (IO['preauthorizationDO'])
              clientRoles = IO['preauthorizationDO']['claimClients'];

            let insureClientRef = clientRoles.find(item => {
              if (item)
                return item['roleCd'] === 'INSURED';
            }) || []

            output = this.clinetDO.find(item => {
              if (item)
                return item['guid'] === insureClientRef.clientRefGuid;
            }) || []
            break;
          }
        }
        case "proposal_ManualUw": {
          if (IO['proposalDO']) {
            let clientRoles: any = [];
            this.clinetDO = IO['clientDOs'];
            clientRoles = IO['proposalDO']['proposalClients']
            let insureClientRef = clientRoles.find(item => {
              if (item)
                return item['roleCd'] === 'INSURED';
            }) || []

            output = this.clinetDO.find(item => {
              if (item)
                return item['guid'] === insureClientRef.clientRefGuid;
            }) || []
            break;
          }
        }

        default: {
          console.log("Invalid choice");
          break;
        }
      }
    }
    return output
  }

  getDateString(rawDate) {
    let dateString
    if (rawDate != null) {
      dateString = moment(rawDate).format('DD MMM YYYY');
    }
    else {
      dateString = 'N/A'
    }
    return dateString
  }

  // subscribeToInsuredListAndInitializeRibbon1() {
  //   this.interactService.insuredSubject$.subscribe(insured => {
  //     console.log("Insured ", insured);
  //     this.tempSelectedClient = insured;
  //     if (this.tempSelectedClient) {
  //       this.clientService.getClientById(this.tempSelectedClient.id)
  //         .subscribe(resp => {
  //           this.selectedClient = resp;
  //         },
  //           (error) => {
  //             throw " Something went wrong";
  //           }
  //         );
  //     }

  //   })
  // }

  subscribeToInsuredListAndInitializeRibbon() {
    this.interactService.insuredClientDOSubject$.subscribe(insured => {
      if (insured)
        this.selectedClient = insured;
    })
  }




}

